import { Button, Flex } from 'antd';

export const StepNavigation = ({ currentStep, totalSteps, onPrev, onNext, navigationLoading, lastStepNextLabel }) => {
  const nextButtonLabel =
    currentStep === totalSteps - 1
      ? (lastStepNextLabel ?? 'Finalizar')
      : 'Continuar';

  return (
    <Flex justify='space-around'>
      <Button
        type='primary'
        ghost
        onClick={onPrev}
        loading={navigationLoading === 'prev'}
        disabled={currentStep === 0 || navigationLoading === 'next'}
      >
        Regresar
      </Button>
      <Button
        type='primary'
        onClick={onNext}
        loading={navigationLoading === 'next'}
        disabled={navigationLoading === 'prev'}
      >
        {nextButtonLabel}
      </Button>
    </Flex>
  );
};